import React, { useCallback, useContext, useRef } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import printer from "../../assets/Printer.png";
import pdf from "../../assets/pdf.png";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import trash from "../../assets/trash.png";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import {
  SetRecoilBillEdit,
  GetRecoilBillListData,
  SetRecoilBillListData,
} from "../../store/billsAtom";
import { purchaseService } from "../../services/purchase.service";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import BillsDetailsScroll from "./BillsDetailsScroll";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid } from "@mui/material";
import BillHistory from "./BillHistory";
import { useReactToPrint } from "react-to-print";
import BillPaymentMade from "./BillPaymentMade";
import { ImAttachment } from "react-icons/im";
import { FaFilePdf } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoPrintSharp } from "react-icons/io5";
import BillsOverview from "./BillsOverview";

const BillsDetailsPage = () => {
   const [billDetails, setBillDetails] = useState({
    Bill_details: [],
      Count_Information: [],
      Action_Status: [],
      payment_detail: [],
    });
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setBillToEdit = SetRecoilBillEdit();
  const setBillListData = SetRecoilBillListData();
  const logicContext = useContext(LogicContext);
  const [tabValue, setTabValue] = React.useState("1");
  const componentRef = useRef();

  const { bill_id } = useParams();
  const navigate = useNavigate();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    document.title = "Bill Details";
    let isMounted = true;
    purchaseService.getBillDetails(bill_id).then((res) => {
      if (isMounted && res.data !== undefined) {
        setBillDetails(res.data);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [bill_id]);

  function reloadBillDetails() {
    purchaseService.getBillDetails(bill_id).then((res) => {
      if (res.data !== undefined) {
        setBillDetails(res.data);
        setBillListData((prev) => {
          let newList = prev["Bill_Info"].map((item, index) => {
            if (item?.Bill_Ref_No === res.data.Bill_Ref_No) {
              return res.data;
            } else {
              return item;
            }
          });
          return { ...prev, Bill_Info: newList };
        });
      }
    });
  }




  const generalReloadBillList = async () => {
    purchaseService.getBillsList().then((response) => {
      if (response?.data !== undefined) {
        setBillListData(response.data);
      }
    });
  };

  const EditVendorDetails = async () => {
    const response = await myPromiseModal({
      title: "Modify Bill Record",
      body: " Do you want to modify this record?",
      showInput: false,
      placeHolder: "",
    });
    if (response.decision === true) {
      setBillToEdit(billDetails);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  function onSelection(list) {
    let tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  }

  function viewBillDetails(bill_id) {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${bill_id}`
    );
  }


  function viewVendor(vendor_id) {
    navigate(
      `/${currModuleId}/${currModuleName}/${"vendors"}/details/${vendor_id}`
    );
  }


  const deleteBillHandler = async () => {
    await myPromiseModal({
      title: "confirm your Delete!",
      body: `Do you want to delete ${billDetails?.Bill_Number} ?`,
      showInput: false,
      placeHolder: "",
    }).then((response) => {
      if (response.decision === true) {
        let option = 12;
        let temp = `<a> <refno> ${billDetails?.Bill_Ref_No} </refno> </a>`;
        let xml_string_refno = `<root> ${temp} </root>`;
        purchaseService
          .setBillBulkAction({ xml_string_refno, option })
          .then((res) => {
            if (res?.data !== undefined) {
              const { message_text } = res.data[0];
              logicContext.showToast(message_text, "success");
              navigate(-1);
              return generalReloadBillList();
            }
          })
          .catch((err) => {
            logicContext.showToast("Error", "error");
          });
      }
    });
  };



  
     const singleActionPerform = useCallback(
          async action => {
            const result = await myPromiseModal({
              title: 'Confirm your action!',
              body: `This Purchase Order status will be ${action.Status_Name}?`,
              showInput: false,
              placeHolder: 'Enter message',
            });
    
            console.log("res ", result);
     
      
            if (result.decision === true) {
              const formData = { xml_string_refno: ` <root><a><refno>${bill_id}</refno></a></root>`, option: action.Action_Option };
              purchaseService.billDetailsAction(formData)
                .then(res => {
                  if (res?.data !== undefined) {
                    const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
                    const { message_id, message_text } = cleanResponse;
  
                    if (message_id == 1) {
                      logicContext.showToast(message_text, 'success');
                      reloadBillDetails();
                      generalReloadBillList();
                    }
                  }
                })
                .catch(err => {
                  logicContext.showToast("error", 'error');
                });
            }
          },
          [myPromiseModal]
        );
    

        

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <section className="mt-6">


        <section className="mb-6">
          <div className="flex justify-end">
            <div className="flex flex-col lg:flex-row space-y-3 lg:space-y-0 lg:space-x-4 items-center">
              <div className="flex items-center space-x-2">
                {/* <span className="text-gray-700 font-medium">{magicButtons(billDetails?.Bill_Status_Name)}</span> */}
                {billDetails?.Action_Status?.length > 0 && (
                              <Dropdown>
                                <Dropdown.Toggle className="text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md px-4 py-2" id="dropdown-basic">
                                  ACTION
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="mt-1 shadow-lg border border-gray-200 rounded-md bg-white">
                                  {billDetails?.Action_Status?.map((option, i) => (
                                    <Dropdown.Item className="hover:bg-gray-100" key={i} onClick={() => singleActionPerform(option)}>
                                      <div className="text-sm text-gray-700 py-2 px-4">{option?.Status_Name}</div>
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
              </div>
              <div className="flex items-center space-x-2">
                <div className="p-1.5 rounded-md hover:bg-gray-200 cursor-pointer transition">
                  <ImAttachment className="h-[20px] w-[20px] text-gray-600" />
                </div>
                <div onClick={() => handlePrint()} className="p-1.5 rounded-md hover:bg-gray-200 cursor-pointer transition">
                  <FaFilePdf className="h-[20px] w-[20px] text-gray-600" />
                </div>
                <div onClick={() => handlePrint()} className="p-1.5 rounded-md hover:bg-gray-200 cursor-pointer transition">
                  <IoPrintSharp className="h-[23px] w-[23px] text-gray-600" />
                </div>
                <div onClick={() => EditVendorDetails()} className="p-1.5 rounded-md hover:bg-gray-200 cursor-pointer transition">
                  <MdEdit className="h-[23px] w-[23px] text-gray-600" />
                </div>
                <div onClick={() => deleteBillHandler()} className="p-1.5 rounded-md hover:bg-gray-200 cursor-pointer transition">
                  <MdDelete className="h-[23px] w-[23px] text-gray-600" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="flex space-x-4">
          <div className="w-[210px]">
            <BillsDetailsScroll onSelection={onSelection} viewBillDetails={viewBillDetails}></BillsDetailsScroll>
          </div>
          <div className="flex-1 overflow-x-hidden">
            <TabContext value={tabValue} className="w-full">
              <Box className="mb-4">
                <TabList onChange={handleTabChange} aria-label="lab API tabs example" className="border-b border-gray-200">
                  <Tab label="Details" value="1" className="focus:outline-none py-2 px-4 text-gray-700 hover:bg-gray-100 rounded-t-lg" />
                  {billDetails?.Count_Information?.length > 0 && (
                    <Tab
                      label={`Payment Made (${billDetails?.payment_detail?.length || 0})`}
                      value="2"
                      className="focus:outline-none py-2 px-4 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                    />
                  )}
                  {billDetails?.Count_Information?.length > 0 && (
                    <Tab
                      label={`Comments & History (${billDetails?.Count_Information[0]?.History_Count})`}
                      value="3"
                      className="focus:outline-none py-2 px-4 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                    />
                  )}
                </TabList>
              </Box>
              <TabPanel value="1" className="p-0">
                <BillsOverview billDetails={billDetails} viewVendor={viewVendor} ref={componentRef} />
              </TabPanel>
              <TabPanel value="2" className="p-0">
                <BillPaymentMade payments={billDetails?.payment_detail} />
              </TabPanel>
              <TabPanel value="3" className="p-0">
                <BillHistory />
              </TabPanel>
            </TabContext>
          </div>
        </div>

        <section className="flex justify-between mt-6">
          <section className="w-full">
            <section className="text-gray-600 flex justify-between md:mt-5"></section>
          </section>
        </section>
      </section>
    </>
  );
};

export default BillsDetailsPage;
